export default {
    icons: [
        //{id: '{$appId}', label: '', url: ''},
    ]
  }
